module.exports = __webpack_public_path__ + "media/images/ui__infoBox-b0c44bd217afa4bce06368907d64e7dd.png";